import * as FolderActions from '../../actions/folders';
import { reducer } from '../reducerUtils';

const initialState = {
  isNavigatingFolders: false,
  folderMaps: {},
  isFetchingFolders: false,
};

export default reducer({
  [FolderActions.NAVIGATING_FOLDERS]: (state, action) => ({
    ...state,
    isNavigatingFolders: action.payload,
  }),

  [FolderActions.SET_FOLDER_MAPS]: (state, action) => ({
    ...state,
    folderMaps: action.payload.folders,
    isFetchingFolders: false,
  }),

  [FolderActions.CLEAR_FOLDER_MAP]: (state) => ({
    ...state,
    folderMaps: {},
  }),
  [FolderActions.IS_FETCHING_FOLDERS]: (state) => ({
    ...state,
    isFetchingFolders: true,
  }),
  [FolderActions.IS_FETCHING_FOLDERS_COMPLETE]: (state) => ({
    ...state,
    isFetchingFolders: false,
  }),
}, initialState);
